import DeletedMessagesList from "../models/DeletedMessagesList";

const DeletedMessagesStore = DeletedMessagesList.create();

export default DeletedMessagesStore;
